import { Link } from '@tanstack/react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

export function TvSlider({ items }: { items: ArticleCardData[] }) {
  if (items.length === 0) return null;
  return (
    <section className="single-play-post-area mt-10">
      <div className="container custom-container">
        <div className="single-play-box">
          <div className="single-play-post-slider" style={{ position: 'relative' }}>
            <Swiper
              modules={[Navigation, Autoplay]}
              dir="rtl"
              slidesPerView={2}
              spaceBetween={20}
              loop={items.length > 2}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              speed={1000}
              navigation={{ prevEl: '[data-tv-next]', nextEl: '[data-tv-prev]' }}
              breakpoints={{ 0: { slidesPerView: 1 }, 992: { slidesPerView: 2 } }}
            >
              {items.map((article) => (
                <SwiperSlide key={article.id}>
                  <div className="single-play-post-item">
                    <SmartImage media={article.coverMedia} alt={article.title} />
                    <div className="single-play-post-content">
                      <div className="post-meta">
                        {article.category && (
                          <div className="meta-categories">
                            <CategoryLink slug={article.category.slug} name={article.category.name} />
                          </div>
                        )}
                        <div className="meta-date">
                          <span>{formatPublishedAt(article.publishedAt)}</span>
                        </div>
                      </div>
                      <h3 className="title">
                        <Link to="/articles/$slug" params={{ slug: article.slug }}>{article.title}</Link>
                      </h3>
                    </div>
                    <div className="play-btn">
                      <Link
                        className="video-popups"
                        to="/articles/$slug"
                        params={{ slug: article.slug }}
                        aria-label={article.title}
                      >
                        <i className="fas fa-play" aria-hidden="true" />
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <span data-tv-prev className="prev slick-arrow" aria-label="السابق" role="button" tabIndex={0}>
              <i className="fal fa-angle-left" />
            </span>
            <span data-tv-next className="next slick-arrow" aria-label="التالي" role="button" tabIndex={0}>
              <i className="fal fa-angle-right" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
